import {Service} from '../Service';
import {asNumber} from '../../../common/helpers/converters/asNumber';

export class AgentsService extends Service {
    async assignAgents(groupId: number, agentIds: string[]) {
        const agentsApi = await this.services.aat.Agents;

        const response = await agentsApi.assignAgents({
            id: groupId,
            assignAgentsRequest: {
                cmGroupIds: agentIds.map((it) => {
                    return asNumber(it);
                })
            }
        });

        this.checkStatus(response);
    }

    async lockAgents(agentIds: string[], lock: boolean) {
        const agentsApi = await this.services.aat.Agents;

        const response = await agentsApi.lockAgents({
            lockAgentsRequest: {
                cmGroupIds: agentIds.map((it) => {
                    return asNumber(it);
                }),
                lock
            }
        });

        this.checkStatus(response);

        this.db.agents.modify(it => {
            if (agentIds.includes(it.id)) {
                it.locked = lock;

                if (!lock) {
                    delete it.lock_type;
                    delete it.lock_expiration_date;
                }
            }
        });
    }
}